import { render, staticRenderFns } from "./ValidatorList.vue?vue&type=template&id=65ce1c42&"
import script from "./ValidatorList.vue?vue&type=script&lang=js&"
export * from "./ValidatorList.vue?vue&type=script&lang=js&"
import style0 from "./ValidatorList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports